export const usersDownloadSampleData = [
  {
    email: "user1@domain.com",
    phone: "12406856580",
    policyId: "US-Policy",
  },
  {
    email: "user2@domain.com",
    phone: "16042605190",
    policyId: "Canada-Policy",
  },
  {
    email: "user3@domain.com",
    phone: "442037443261",
    policyId: "UK-Policy",
  },
  {
    email: "user4@domain.com",
    phone: "81123456789",
    policyId: "Asia-Policy",
  },
  {
    email: "user5@domain.com",
    phone: "5511984565666",
    policyId: "SouthAmerica-Policy",
  },
  {
    email: "user6@domain.com",
    phone: "27810005933",
    policyId: "Africa-Policy",
  },
  {
    email: "user7@domain.com",
    phone: "61412345678",
    policyId: "Australia-Policy",
  },
  {
    email: "user8@domain.com",
    phone: "491711234567",
    policyId: "Germany-Policy",
  },
  {
    email: "user9@domain.com",
    phone: "491711234568",
    policyId: "USWest-Policy",
  },
  {
    email: "user10@domain.com",
    phone: "",
    policyId: "",
  },
];
